import React, { useEffect, useState, useCallback, useContext } from "react";
import { View, Text, Image } from "react-native-web";
import Header from "./Header";
import Footer from "./Footer";
import Content from "./Content";
import queryString from "query-string";
import { AuthContext } from "../Auth.js";
import { Spin, Button } from "antd";
import Firebase from "firebase";
import app from "../base";

const dbRef = Firebase.database().ref();

const Survey = (props) => {
	const { currentUser } = useContext(AuthContext);
	const [params, setParams] = useState(null);
	const [surveyNotExist, setSurveyNotExist] = useState(false);
	const [currentSurvey, setCurrentSurvey] = useState(null);
	const [notStarted, setNotStarted] = useState(true);
	const [table, setTable] = useState(null);
	const [alreadyTaken, setAlreadyTaken] = useState(false);

	useEffect(() => {
		async function fetchSurveyData() {
			var suggestion = null;
			var survey = null;

			const params = queryString.parse(props.location.search);
			setParams(params);

			if (!params.sid) {
				setSurveyNotExist(true);
				return;
			}

			if (params.p) {
				if (!params.u) {
					// setLoading(false);
					setSurveyNotExist(true);
					return;
				}
				suggestion = await dbRef
					.child(`privatePolls/${params.u}/${params.sid}`)
					.once("value");

				if (suggestion.exists()) {
					survey = suggestion.val();
				} else {
					setSurveyNotExist(true);
				}
				setTable(`privatePolls/${params.u}`);
			} else {
				suggestion = await dbRef.child(`surveys/${params.sid}`).once("value");

				if (suggestion.exists()) {
					survey = suggestion.val();
				} else {
					setSurveyNotExist(true);
					return;
				}
				setTable("surveys");
			}

			if (survey && survey.users) {
				setAlreadyTaken(Object.keys(survey.users).includes(currentUser.uid));
			}

			setCurrentSurvey(survey);
		}
		fetchSurveyData();
	}, [currentUser, props]);

	const submitData = (answers, comment) => {
		var dbRef = Firebase.database()
			.ref()
			.child(`${table}/${currentSurvey.key}`);
		var updates = {};

		updates[`/users/${currentUser.uid}/userid`] = currentUser.uid;
		updates[`/users/${currentUser.uid}/userpicture`] = currentUser.photoURL;
		updates[`/users/${currentUser.uid}/username`] = currentUser.displayName;

		if (comment) {
			updates[`/comments/${currentUser.uid}/username`] =
				currentUser.displayName;
			updates[`/comments/${currentUser.uid}/userid`] = currentUser.displayName;
			updates[`/comments/${currentUser.uid}/userpicture`] =
				currentUser.photoURL;
			updates[`/comments/${currentUser.uid}/comment`] = comment;

			var commentRef = dbRef.child("commentCount");
			commentRef.transaction(function (comment) {
				return comment + 1;
			});
		}

		dbRef.update(updates);

		var responseRef = dbRef.child("totalResponses");
		responseRef.transaction(function (response) {
			return response + 1;
		});

		answers.forEach((item) => {
			if (item) {
				if (
					item.type == "options" ||
					item.type == "boolean" ||
					item.type == "dropdown"
				) {
					if (item.selectedIndex !== -1) {
						updates = {};
						var optionsRef = dbRef.child(
							`response/${item.index}/response/${item.selectedIndex}`
						);
						optionsRef.transaction(function (response) {
							return response + 1;
						});

						var totalRef = dbRef.child(`response/${item.index}/totalCount`);
						totalRef.transaction(function (count) {
							return count + 1;
						});

						updates[
							`response/${item.index}/users/${item.selectedIndex}/${currentUser.uid}/userid`
						] = currentUser.uid;
						updates[
							`response/${item.index}/users/${item.selectedIndex}/${currentUser.uid}/userpicture`
						] = currentUser.photoURL;
						updates[
							`response/${item.index}/users/${item.selectedIndex}/${currentUser.uid}/username`
						] = currentUser.displayName;
						dbRef.update(updates);
					}
				} else if (item.type == "slider" || item.type == "rating") {
					if (item.selectedValue !== -1) {
						updates = {};
						var optionsRef = dbRef.child(
							`response/${item.index}/response/${item.selectedValue}`
						);
						optionsRef.transaction(function (response) {
							return response + 1;
						});

						var totalRef = dbRef.child(`response/${item.index}/totalCount`);
						totalRef.transaction(function (count) {
							return count + 1;
						});

						updates[
							`response/${item.index}/users/${item.selectedValue}/${currentUser.uid}/userid`
						] = currentUser.uid;
						updates[
							`response/${item.index}/users/${item.selectedValue}/${currentUser.uid}/userpicture`
						] = currentUser.photoURL;
						updates[
							`response/${item.index}/users/${item.selectedValue}/${currentUser.uid}/username`
						] = currentUser.displayName;
						dbRef.update(updates);
					}
				} else if (item.type == "check") {
					if (item.selectedIndex.length !== 0) {
						item.selectedIndex.forEach(function (selected, index) {
							if (selected !== -1) {
								updates = {};
								dbRef
									.child(`response/${item.index}/response/${selected}`)
									.transaction(function (response) {
										return response + 1;
									});

								updates[
									`response/${item.index}/users/${selected}/${currentUser.uid}/userid`
								] = currentUser.uid;
								updates[
									`response/${item.index}/users/${selected}/${currentUser.uid}/userpicture`
								] = currentUser.photoURL;
								updates[
									`response/${item.index}/users/${selected}/${currentUser.uid}/username`
								] = currentUser.displayName;
								dbRef.update(updates);
							}
						});

						var totalRef = dbRef.child(`response/${item.index}/totalCount`);
						totalRef.transaction(function (count) {
							return count + item.selectedIndex.length;
						});
					}
				}

				if (item.skipped) {
					var totalRef = dbRef.child(`response/${item.index}/skipCount`);
					totalRef.transaction(function (count) {
						return count + 1;
					});
				}
			}
		});
	};

	if (surveyNotExist) {
		return (
			<View>
				<Header text={"Survey"} />
				<View
					style={{
						alignItems: "center",
						justifyContent: "center",
						height: 300,
					}}
				>
					<Text
						style={{
							fontSize: 20,
							fontWeight: "600",
							marginVertical: 20,
							textAlign: "center",
						}}
					>
						Unable to load Survey, please verify web link
					</Text>
				</View>
			</View>
		);
	} else if (!currentSurvey) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
				}}
			>
				<Spin style={{ marginTop: 20 }} size="large" />
			</div>
		);
	}

	return notStarted && currentSurvey ? (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "100vh",
			}}
		>
			<Image
				source={{ uri: currentSurvey.referenceImage }}
				style={{ height: "100%", width: "100%" }}
			/>
			<View
				style={{
					position: "absolute",
					left: 0,
					right: 0,
					top: 0,
					bottom: 0,
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "rgba(0,0,0,0.4)",
				}}
			>
				<View style={{ flexDirection: "row", justifyContent: "center" }}>
					<Text
						style={{
							fontSize: 15,
							fontWeight: "500",
							textAlign: "center",
							color: currentSurvey.referenceImage ? "#fff" : "gray",
							fontFamily: "NunitoSans"
						}}
					>
						{currentSurvey.category} {" - "}
					</Text>
					<Text
						style={{
							fontSize: 15,
							fontWeight: "500",
							textAlign: "center",
							color: currentSurvey.referenceImage ? "#fff" : "gray",
							fontFamily: "NunitoSans"
						}}
					>
						{currentSurvey.questionCount} {" Questions"}
					</Text>
				</View>
				<Text
					style={{
						fontSize: 30,
						marginTop: 10,
						fontWeight: "600",
						textAlign: "center",
						color: currentSurvey.referenceImage ? "#fff" : "#000",
						fontFamily: "NunitoSans"
					}}
				>
					{currentSurvey.title}
				</Text>
				<View
					style={{
						marginTop: 10,
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<Image
						source={{ uri: currentSurvey.userpicture }}
						style={{ height: 20, width: 20, borderRadius: 15 }}
					/>
					<Text
						style={{
							fontSize: 15,
							marginLeft: 10,
							fontWeight: "500",
							color: currentSurvey.referenceImage ? "#fff" : "gray",
							fontFamily: "NunitoSans"
						}}
					>
						{currentSurvey.username}
					</Text>
				</View>
				<View style={{ flexDirection: "row", justifyContent: "center" }}>
					{alreadyTaken ? (
						<View style={{ alignItems: "center" }}>
							<Text
								style={{
									fontSize: 20,
									marginTop: 30,
									fontWeight: "500",
									color: "#fff",
									fontFamily: "NunitoSans"
								}}
							>
								{"You have already taken the survey"}
							</Text>
							<Button
								type="primary"
								style={{
									borderRadius: 25,
									marginTop: 20,
									height: 40,
									width: 200,
									fontSize: 16,
									fontWeight: "600",
									backgroundColor: "#196BFF",
								}}
								onClick={() => app.auth().signOut()}
							>
								Sign out
							</Button>
						</View>
					) : (
						<Button
							type="primary"
							style={{
								borderRadius: 25,
								marginTop: 20,
								height: 40,
								width: 200,
								fontSize: 16,
								fontWeight: "600",
								backgroundColor: "#196BFF",
							}}
							onClick={() => setNotStarted(false)}
						>
							Start
						</Button>
					)}
				</View>
			</View>
		</div>
	) : (
		<View>
			<Header text={currentSurvey.title} logoImage={currentSurvey.logo} />
			{surveyNotExist ? (
				<View
					style={{
						alignItems: "center",
						justifyContent: "center",
						height: 300,
					}}
				>
					<Text
						style={{
							fontSize: 20,
							fontWeight: "600",
							marginVertical: 20,
							textAlign: "center",
							fontFamily: "NunitoSans"
						}}
					>
						Unable to load Survey, please verify web link
					</Text>
				</View>
			) : (
				currentSurvey && (
					<Content currentSurvey={currentSurvey} submitData={submitData} />
				)
			)}

			{/* <Footer currentSurvey={currentSurvey || null} /> */}
		</View>
	);
};
export default Survey;
